<section class="carousel__desktop d-none d-md-flex">
    <div class="swiper swiper__home desktop">
        <div class="swiper-wrapper">
            <div *ngFor="let promo of promotions" class="swiper-slide">
                <img
                    class="d-flex vw-100"
                    [src]="promo.path"
                    alt="Promotion Image"
                />
                <div class="swiper__container" *ngIf="promo.type !== 'static'">
                    <div class="swiper__middle__container">
                        <div class="swiper__first__subcontainer">
                            <span class="swiper__title">{{
                                promo.hashtag
                            }}</span>
                            <span class="swiper__text">{{ promo.slogan }}</span>
                        </div>
                        <div class="swiper__middle__subcontainer">
                            <span class="swiper__title">{{
                                'fe_carousel_use_discount' | translate
                            }}</span>
                            <span class="swiper__discount"
                                >{{ promo.discount }}%</span
                            >
                            <span class="swiper__text">{{
                                'fe_carousel_of_discount' | translate
                            }}</span>
                        </div>
                        <div class="swiper__last__subcontainer">
                            <span class="swiper__title">{{
                                'fe_carousel_base_and_protections' | translate
                            }}</span>
                            <fe-button
                                [style]="'promo'"
                                (click)="applyPromo(promo.code)"
                            >
                                <span>{{
                                    'fe_carousel_apply_coupon' | translate
                                }}</span>
                                <span class="promo__coupon">{{
                                    promo.code
                                }}</span>
                            </fe-button>
                        </div>
                    </div>
                    <div class="swiper__right__container">
                        <a
                            [routerLink]="
                                'questions/terms-and-conditions' | formatUrl
                            "
                            class="p_bold"
                        >
                            {{ 'fe_carousel_terms_and_conditions' | translate }}
                        </a>
                        <span
                            >{{ 'fe_carousel_expiral' | translate }}
                            {{
                                promo.startDateBooking
                                    | formatBookingDates: promo.endDateBooking
                            }}</span
                        >
                        <span
                            >{{ 'fe_carousel_rent_date' | translate }}
                            {{
                                promo.startDateRent
                                    | formatBookingDates: promo.endDateRent
                            }}</span
                        >
                    </div>
                </div>
            </div>
        </div>
        <div class="swiper-pagination"></div>
    </div>
</section>

<section class="carousel__mobile d-flex d-md-none">
    <div class="swiper swiper__home mobile">
        <div class="swiper-wrapper">
            <div *ngFor="let promo of filteredPromotions" class="swiper-slide">
                <img
                    class="d-flex"
                    [src]="
                        promo.pathMobile
                            ? promo.pathMobile
                            : promo.type !== 'static'
                              ? ('images/banner_dynamic.svg' | cdn)
                              : promo.path
                    "
                    alt="Promotion Image"
                />
                <div class="swiper__container" *ngIf="promo.type !== 'static'">
                    <div class="swiper__left__container">
                        <div class="swiper__top__subcontainer">
                            <span class="swiper__title">{{
                                'fe_carousel_use_discount' | translate
                            }}</span>
                            <span class="swiper__discount"
                                >{{ promo.discount }}%</span
                            >
                            <span class="swiper__text">{{
                                'fe_carousel_of_discount' | translate
                            }}</span>
                        </div>
                        <div class="swiper__bottom__subcontainer">
                            <a
                                [routerLink]="
                                    'questions/terms-and-conditions' | formatUrl
                                "
                                class="p_bold"
                            >
                                {{
                                    'fe_carousel_terms_and_conditions'
                                        | translate
                                }}
                            </a>
                        </div>
                    </div>
                    <div class="swiper__right__container">
                        <span class="swiper__title">{{
                            'fe_carousel_base_and_protections' | translate
                        }}</span>
                        <fe-button
                            [style]="'promo-mobile'"
                            (click)="applyPromo(promo.code)"
                        >
                            <span class="text__coupon">{{
                                'fe_carousel_apply_coupon' | translate
                            }}</span>
                            <span class="promo__coupon">{{ promo.code }}</span>
                        </fe-button>
                        <span class="swiper__text"
                            >{{ 'fe_carousel_expiral' | translate }}
                            {{
                                promo.startDateBooking
                                    | formatBookingDates: promo.endDateBooking
                            }}</span
                        >
                    </div>
                </div>
            </div>
        </div>
        <div class="swiper-pagination"></div>
    </div>
</section>
